import theme from 'ThemeProvider/theme';
import sx from 'utils/createSx';

export default sx({
  container: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    p: 4,
    backgroundColor: '#f9f9f9',
  },
  successCard: {
    borderRadius: 4,
    boxShadow: '0px 8px 24px rgba(0, 0, 0, 0.12)',
    mb: 3,
    backgroundColor: '#fff',
    border: `2px solid ${theme.palette.success.main}`,
  },
  successContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    py: 4,
  },
  successIcon: {
    fontSize: 80,
    color: theme.palette.success.main,
    mb: 2,
  },
  successTitle: {
    fontWeight: 'bold',
    color: theme.palette.success.main,
    mb: 1,
  },
  orderNumber: {
    fontWeight: 'bold',
    color: theme.palette.primary.main,
  },
  summaryCard: {
    borderRadius: 4,
    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
    mb: 3,
    backgroundColor: '#fff',
  },
  statusCard: {
    borderRadius: 4,
    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
    mb: 4,
    backgroundColor: '#fff',
  },
  sectionTitle: {
    fontWeight: 'bold',
    color: theme.palette.primary.main,
    mb: 2,
  },
  orderInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
  },
  infoRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    py: 1,
  },
  totalAmount: {
    fontWeight: 'bold',
    color: theme.palette.success.main,
    fontSize: '1.1rem',
  },
  statusList: {
    p: 0,
  },
  statusItem: {
    px: 0,
    py: 2,
  },
  statusIcon: {
    fontSize: 32,
    color: theme.palette.primary.main,
    mr: 2,
  },
  statusDivider: {
    mx: 0,
  },
  actionButtons: {
    display: 'flex',
    flexDirection: { xs: 'column', sm: 'row' },
    gap: 2,
    justifyContent: 'center',
    alignItems: 'center',
  },
  viewOrdersButton: {
    borderColor: theme.palette.primary.main,
    color: theme.palette.primary.main,
    fontWeight: 'bold',
    minWidth: { xs: '100%', sm: '200px' },
    '&:hover': {
      borderColor: theme.palette.primary.dark,
      backgroundColor: theme.palette.primary.light,
    },
  },
  continueShoppingButton: {
    backgroundColor: theme.palette.success.main,
    color: '#fff',
    fontWeight: 'bold',
    minWidth: { xs: '100%', sm: '200px' },
    '&:hover': {
      backgroundColor: theme.palette.success.dark,
    },
  },
});
